<div class="h-screen w-screen flex py-8 md:p-0 md:items-center justify-center">
  <div class="bg-offwhite-100 rounded-xl center w-11/12 md:w-3/4 login-container-height shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
    <div class="flex flex-col h-full">
      <div class="flex flex-row h-full">
        <div class="flex flex-col h-full w-full md:w-3/5 p-4 pr-2  overflow-y-auto">
          @if (!isBluebird) {
            <img src="/assets/logo.png" class="md:hidden max-h-24 mr-4 mt-4 object-scale-down flex justify-self-start"
              />
          }
          @if (isBluebird) {
            <img src="/assets/bluebirdlogo.png"
              class="md:hidden max-h-24 mr-4 mt-4 object-scale-down flex justify-self-start" />
          }
          @if (!showForgotPassword) {
            <div class="flex flex-col justify-center">
              <h1 class="p-4 md:p-8 md:pt-12 pt-16">Login</h1>
              <div class="md:px-8 px-4 pb-4">
                <label class="block pt-4">
                  <span class="">Username/Email</span>
                  <input type="text" [(ngModel)]="username" class="text-box" #usernameElement />
                </label>
                <label class="block pt-6">
                  <span class="">Password</span>
                  <input type="password" [(ngModel)]="password" class="text-box" (keypress)="checkLogin($event)" />
                </label>
                <div class="pt-10">
                  <button class="btn-primary-full" (click)="login()" [class.disabled]="!signInAllowed"
                    [disabled]="!signInAllowed">
                    @if (signInAllowed) {
                      <span>Login</span>
                    }
                    @if (!signInAllowed) {
                      <span>Signing In...</span>
                    }
                  </button>
                </div>
                @if (errorText != '') {
                  <span class="form-error">{{
                    errorText
                  }}</span>
                }
                <div class="pt-8">
                  <a (click)="showForgot()" class="text-sm block underline hover:cursor-pointer">Forgotten your
                  Password?</a>
                </div>
              </div>
              <div class="flex flex-row my-3 md:mx-6 mx-4 ">
                @if (isBluebird) {
                  <a href="https://apps.apple.com/us/app/bluebird-care-quality-app/id6739705696">
                    <img src="/assets/mobile-app-badges/app-store.svg" class=" hover:cursor-pointer h-10 lg:mr-4" />
                  </a>
                }
                @if (!isBluebird) {
                  <a   href="https://apps.apple.com/ca/app/care-audits/id6670390924">
                    <img src="/assets/mobile-app-badges/app-store.svg" class=" hover:cursor-pointer h-10 lg:mr-4" />
                  </a>
                }
                @if (!isBluebird) {
                  <a   href="https://play.google.com/store/apps/details?id=com.careaudits.app">
                    <img src="/assets/mobile-app-badges/google-play.png" class="h-10 hover:cursor-pointer" />
                  </a>
                }
                @if (isBluebird) {
                  <a   href="https://play.google.com/store/apps/details?id=com.careaudits.app.bluebird">
                    <img src="/assets/mobile-app-badges/google-play.png" class="h-10 hover:cursor-pointer" />
                  </a>
                }
              </div>
              <div class="bg-grey-50 rounded-md p-5 mt-4 md:mx-5 mx-4 hidden">
                <div>
                  <h5>Legacy Care Audits</h5>
                  <p class="text-sm mt-2">If your organisation has not yet switched to the new Care Audits system, please follow the below link. If you have any queries please contact support <a
                  href="mailto:care@careaudits.co.uk">care&#64;careaudits.co.uk</a>.</p>
                  <button class="btn-inverse mt-2" (click)="openLegacyLogin()">Legacy Login</button>
                </div>
              </div>
            </div>
          }
          @if (showForgotPassword) {
            <div class="flex flex-col justify-center">
              <h1 class="p-4 md:p-8 md:pt-12 pt-16">Password Reset</h1>
              <div class="md:px-8 px-4">
                <a (click)="showLogin()" class="text-sm block underline hover:cursor-pointer">
                < Back to Login</a>
              </div>
              <div class="md:px-8 px-4 pt-6">
                <label class="block pt-4">
                  <span class="">Email</span>
                  <input type="email" [(ngModel)]="email" class="text-box" />
                </label>
                <div class="pt-10">
                  <button class="btn-primary-full" (click)="resetPassword()" [class.disabled]="email.length == 0"
                    [disabled]="email.length == 0 || resetClicked">
                    @if (!resetClicked) {
                      <span>Reset Password</span>
                    }
                    @if (resetClicked) {
                      <span>Sending Reset Email...</span>
                    }
                  </button>
                  @if (resetEmailSent) {
                    <span class="pt-4">An email will be sent to you if an account has been
                    found.</span>
                  }
                  @if (resetErrorMessage) {
                    <span class="pt-4 form-error">An error occurred resetting your password,
                    please try again later.</span>
                  }
                </div>
              </div>
            </div>
          }

        </div>
        @if (!isBluebird) {
          <div class="flex-col justify-between w-2/5 p-4 pl-2 pb-0 bg-offwhite-500 rounded-xl hidden md:flex"
            >
            <img src="/assets/logo.png" class="p-4 mt-4 center max-h-28 object-scale-down" />
            <div class="max-h-[70%] self-center">
              @if (!isBluebird) {
                <img src="/assets/tabletuser.png" class="object-bottom object-cover max-h-[450px]" />
              }
            </div>
          </div>
        }
        @if (isBluebird) {
          <div class="flex-col justify-between w-2/5 pb-0 bg-offwhite-500 rounded-xl hidden md:flex ">
            <img src="/assets/bluebirdlogo.png" class="p-4 mt-4 center max-h-28 object-scale-down" />
            <div class="bg-[url('/assets/bluebirdswirlsmall.png')] bg-repeat h-full">
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>